import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import { MarketCards } from "./Game";

export const MarketsAndEquitySection = ({risk_value_warning_text, mk_market_card_props, locked_markets, locked_reason, crypto_warning_text, no_volume_warning_text}) => {
    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/markets-color-0.svg"/><span className="ad_120_bold pl-2"><T>Markets</T></span>
                    <p>
                    <small><T>Choose which markets the game players can invest in</T></small>
                    </p>
                </Col>
            </Row>

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    {risk_value_warning_text}
                </Col>
            </Row>

            <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="stock" justify="left" is_settings = {true} is_market = {true} />

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/assets-icon-0.svg"/><span className="ad_120_bold pl-2"><T>Assets</T></span>
                </Col>
            </Row>
            

            <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="assets" justify="left" is_settings = {true} is_market = {true} />

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/commodity-icon-0.svg"/><span className="ad_120_bold pl-2"><T>Commodity Market</T></span>
                </Col>
            </Row>

            <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="commodity" justify="left" is_settings = {true} is_market = {true} />

            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/crypto-icon-color-0.svg"/><span className="ad_120_bold pl-2"><T>Crypto</T></span>
                    {crypto_warning_text}
                    {no_volume_warning_text}
                </Col>
            </Row>

            <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="crypto" justify="left" is_settings = {true} is_market = {true} />
            <div className="pb-4"></div>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/MarketsAndEquitySection.js